
export const state = {
    admission_processing_loaded: false,
    admission_processing_tab_index: {
        tabIndex: 0,
        selAcademicYearId_2: -1,
        selCampusId_2: -1,
        qualificationId_0: -1,
        selAcademicYearId_5: -1,
        selCampusId_5: -1,
        qualificationId_1: -1,
        selAcademicYearId_3: -1,
        selCampusId_3: -1,
        qualificationId_2: -1,
        selAppType: -1
    },
};

export const getters = {
    getterAdmissionProcessingLoaded: state => state.admission_processing_loaded,
    getterAdmissionProcessingTabIndex: state => state.admission_processing_tab_index,
};

export const mutations = {
    SET_ADMISSION_PROCESSING_LOADED(state, newValue) {
        state.admission_processing_loaded = newValue
    },
    SET_ADMISSION_PROCESSING_TAB_INDEX(state, newValue) {
        state.admission_processing_tab_index = newValue
    },
};

export const actions = {
    initAdmissionProcessingTabValues({ commit }) {
        commit('SET_ADMISSION_PROCESSING_LOADED', false);
        commit('SET_ADMISSION_PROCESSING_TAB_INDEX', {
            tabIndex: 0,
            selAcademicYearId_2: -1,
            selCampusId_2: -1,
            qualificationId_0: -1,
            selAcademicYearId_5: -1,
            selCampusId_5: -1,
            qualificationId_1: -1,
            selAcademicYearId_3: -1,
            selCampusId_3: -1,
            qualificationId_2: -1,
            selAppType: -1
        });
    },
    setAdmissionProcessingTabValues({ commit }, values) {
        commit('SET_ADMISSION_PROCESSING_LOADED', true);
        commit('SET_ADMISSION_PROCESSING_TAB_INDEX', values);
    },
};
